function merge(...objects) {
	const isObject = obj => obj && typeof obj === 'object';
	const mergeReducer = (accumulator, object) => {
		Object.keys(object).forEach(key => {
			const accumulatorValue = accumulator[key];
			const objectValue = object[key];

			if (Array.isArray(accumulatorValue) && Array.isArray(objectValue)) {
				accumulator[key] = accumulatorValue.concat(...objectValue);
			} else if (isObject(accumulatorValue) && isObject(objectValue)) {
				accumulator[key] = merge(accumulatorValue, objectValue);
			} else {
				accumulator[key] = objectValue;
			}
		});
		return accumulator;
	};

	return objects.reduce(mergeReducer, {});
}

function map(o, m) {
	const objects = [];
	const valueReducer = (accumulator, currentValue) =>
		accumulator && Object.prototype.hasOwnProperty.call(accumulator, currentValue)
			? accumulator[currentValue]
			: null;
	const objectReducer = (accumulator, currentValue) => ({ [currentValue]: accumulator });

	Object.entries(m).forEach(([a, b]) => {
		const value = a.split('.').reduce(valueReducer, o);
		const object = value !== null ? b.split('.').reverse().reduce(objectReducer, value) : null;

		if (object !== null) {
			objects.push(object);
		}
	});

	return merge(...objects);
}

export default {
	map
};
